import { HttpRequest } from '@angular/common/http';
import { RequestData } from '@lentau/api/shared/monolith/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRequestFromFormUrlencoded = (request: HttpRequest<any>): RequestData => {
  return JSON.parse(request.body.replace(`request=`, ''));
};
